module.exports = __webpack_public_path__ + "static/media/flyer-2032-en.cd5fb780.pdf";